import { ThemeOptions } from "@mui/material";

export const muiSnackbar: ThemeOptions["components"] = {
  MuiSnackbar: {
    styleOverrides: {
      root: ({ theme }) => ({
        [theme.breakpoints.up("md")]: {
          width: "620px",
        },
        [theme.breakpoints.down("md")]: {
          width: "570px",
        },
        [theme.breakpoints.down("sm")]: {
          width: "unset",
          left: theme.spacing(5),
          right: theme.spacing(5),
        },
      }),
    },
  },
};
